import React, { useState } from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import FileUpload from "../../Common/FileUpload";
import { useHistory } from "react-router-dom";
import Errors from "../../../constants/Errors.json";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as RolesActions from "../../../store/actions/Roles";
import * as UserActions from "../../../store/actions/User";

import NoFooterModal from "../../Common/NoFooterModal";
import Button from "sushiweb/Button";
import InformationBar from "../../Common/InformationBar";

import {
  BottomSectionModal,
  UploadCsvOption,
  NotesSection,
} from "../../../constants/assets/containers";

const BulkUploadRolesModal = ({ bulkUploadRoles, setStatus }) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const sample_download_url = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/bulk_upload_auth_details.csv`
      : ""
  }`;

  const instructions = [
    "Please provide data as per the format in the sample file.",
    "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  ];

  const handleClose = () => {
    history.push("/");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!activeFile) {
      return;
    }
    bulkUploadRoles({
      filename: "auth_detail",
    }).then((res) => {
      if (res) {
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const handleFileChange = (file) => {
    setActiveFile(file);
  };

  return (
    <BulkUploadRolesModalContainer>
      <NoFooterModal
        header
        heading="Bulk Upload Roles"
        handleClose={handleClose}
        id="uploadRolesModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="uploadRoles"
              disabled={activeFile === ""}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <UploadCsvOption>
          <FileUpload
            title="CSV"
            uploadUrl="/auth-details"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={handleFileChange}
            acceptTypes=".csv, .xls, .xlsx"
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </BulkUploadRolesModalContainer>
  );
};

const BulkUploadRolesModalContainer = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    bulkUploadRoles: bindActionCreators(RolesActions.bulkUploadRoles, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(BulkUploadRolesModal);
